const zhCN = {
  pageErrTitle: '页面错误',
  pageErrContent: '信息错误，请返回人员管理列表！',
  backBtn: '返回',
  
  selectedPersonnelCountTips: '已选择人员',
  listPersonName: '姓名',
  listPersonIDNumber: '证件号',
  listPersonOrg: '所属',
  listPersonOperation: '操作',
  listPersonRemoveBtn: '移除',

  devicesTable: '设备列表',

  searchOrgTxt: '所属机构',
  searchDeviceStatus: '设备状态',
  searchDeviceStatusAllOption: '全部',
  searchDeviceSNOrName: '设备SN/设备名称',
  searchBtn: '搜索',
  
  listDeviceSN: '设备SN',
  listDeviceName: '设备名称',
  listDeviceStatus: '设备状态',
  listDeviceOrg: '所属',

  requestDeviceFail: '获取设备信息失败！',

  submitBtn: '确认授权',
  backListBtn: '返回列表',

  authorizeSuccess: '提交授权信息成功！',
  authorizeFail: '提交授权信息失败！'
}
const enUS = {
  pageErrTitle: 'Page Error',
  pageErrContent: 'Page error, please return to the personal management list!',
  backBtn: 'Back',

  selectedPersonnelCountTips: 'Selected Personnel',

  listPersonName: 'Name',
  listPersonIDNumber: 'ID Number',
  listPersonOrg: 'Organization',
  listPersonOperation: 'Operation',
  listPersonRemoveBtn: 'Remove',

  devicesTable: 'Devices Table',

  searchOrgTxt: 'Organization',
  searchDeviceStatus: 'Status',
  searchDeviceStatusAllOption: 'All',
  searchDeviceSNOrName: 'SN/Name',
  searchBtn: 'Search',

  listDeviceSN: 'SN',
  listDeviceName: 'Name',
  listDeviceStatus: 'Status',
  listDeviceOrg: 'Organization',

  requestDeviceFail: 'Request devices failed!',

  submitBtn: 'Authorize',
  backListBtn: 'Back',

  authorizeSuccess: 'Submit authorization successfully!',
  authorizeFail: 'Submit authorization failed!'
}

export default { zhCN, enUS }